import React from "react";
import "./wwu.css";

import img1 from "../Assets/tv.png";
import img2 from "../Assets/disc.png";
import img3 from "../Assets/repost-dc.png";
import img4 from "../Assets/patients.png";

const features = [
  {
    title: "Schedule Your Visit",
    desc: "Choose your preferred specialty, doctor, and time slot through our website or by calling our appointment desk. Once you reach the hospital our front desk team would assist you with registration process.",
    image: img1,
  },
  {
    title: "Meet Your Doctor",
    desc: "Consult with our experienced specialists who would evaluate, and suggest the necessary diagnostic tests (available in house for quick results) or treatment.",
    image: img2,
  },
  {
    title: "Personalized Treatment Plan",
    desc: "Based on your diagnosis, a clear and customized treatment plan would be proposed, including any follow-up visits.",
    image: img3,
  },
  {
    title: "Ongoing Care",
    desc: "We believe care doesn’t end with a consultation. Our ongoing medical support your recovery recover every step of the way",
    image: img4,
  },
];

function WeAreWithu() {
  return (
    <div className="feature-sec">
      <div className="feature-container">
        <h2 className="feature-heading">
          From Booking to Recovery – We’re With You
        </h2>
        <div className="feature-section">
          {features.map((feature, index) => (
            <div
              className={`feature-item ${
                index % 2 === 0 ? "normal" : "reverse"
              }`}
              key={index}
            >
              <div className={`feature-img`}>
                <img src={feature.image} alt={feature.title} />
              </div>
              <div className="feature-text">
                <h3>{feature.title}</h3>
                <p>{feature.desc}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}

export default WeAreWithu;
